import { observable } from 'mobx'

import ModelStore from '../../../shared-lib/stores/ModelStore'
import { $RootStore } from '../../../src/stores/RootStore'

export interface $ExternalReview {
  _id: string
  professionalId: string
  externalBookingId?: string
  secretSpaReviewId?: string
  externalClientName: string
  rating: number
  publicComment: string
  privateComment: string
  visible: boolean
  createdAt: Date
  googleReviewId?: string
  googleReviewReplyComment?: string
  googleReviewReplyUpdateTime?: Date
}

export type $ExternalReviewModel = ExternalReviewModel

export default class ExternalReviewModel extends ModelStore {
  nullableKeys = ['googleReviewReplyComment', 'googleReviewReplyUpdateTime']

  @observable accessor data: $ExternalReview = {
    _id: '',
    professionalId: '',
    externalBookingId: '',
    secretSpaReviewId: '',
    externalClientName: '',
    rating: 0,
    publicComment: '',
    privateComment: '',
    visible: false,
    createdAt: new Date(),
    googleReviewId: '',
    googleReviewReplyComment: '',
    googleReviewReplyUpdateTime: undefined,
  }

  constructor(data: Partial<$ExternalReview>, rootStore: $RootStore) {
    super(data, rootStore)
    this.merge(data)
  }

  // TO REMOVE, JUST FOR TESTING
  save_api = () => {
    return Promise.resolve(this)
  }
}
